import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Image, Modal, TouchableOpacity, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../../services/window-information';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import DragAndZoom from '../../../components/DragAndZoom';

interface Props {
    imageUrl: string;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ImageModal({ imageUrl, isModalVisible, setIsModalVisible }: Props) {
    const windowInfo = WindowInformation();
    const { styles, theme } = useStyles(styleSheet);

    return <Modal
        animationType='fade'
        transparent={true}
        visible={isModalVisible}
        onRequestClose={() => setIsModalVisible(false)}>
        <View style={[styles.modalContainer]}>
            <View style={styles.centeredView}>
                <View style={styles.modalBody}>
                    <View style={{ alignItems: 'flex-end' }}>
                        <TouchableOpacity
                            style={{ width: 40, height: 40 }}
                            onPress={() => setIsModalVisible(false)}
                        >
                            <FontAwesomeIcon icon={faTimes} fontSize={40} color={theme.colors.iconColor} />
                        </TouchableOpacity>
                    </View>
                    <View style={styles.imageContainer}>
                        <DragAndZoom>
                            <Image source={{ uri: imageUrl }} style={{
                                width: windowInfo.width - 70,
                                height: windowInfo.height - 100,
                                resizeMode: 'contain',
                            }} />
                        </DragAndZoom>
                    </View>
                </View>
            </View>
        </View>
    </Modal>;
}

const styleSheet = createStyleSheet((theme) => ({
    modalContainer: {
        flex: 1,
        backgroundColor: '#31313199'
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalBody: {
        backgroundColor: theme.colors.container.background,
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: 8,
        flex: 1,
        padding: 10,
        width: '95%',
        maxHeight: '70%'
    },
    imageContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    }
}));
